/**
 * @flow
 */

import React from 'react';
import { Select } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const options = [
    {
        value: 'SERVICE',
        text: (
            <FormattedMessage
                id="pages.appointments.details.invoice.InvoiceForm.service"
                defaultMessage="Service"
            />
        ),
    },
    {
        value: 'PRODUCT',
        text: (
            <FormattedMessage
                id="pages.appointments.details.invoice.InvoiceForm.product"
                defaultMessage="Product"
            />
        ),
    },
];

// `meta` (redux-form leftover) is stripped so it doesn't leak onto the Select.
const TypeField = ({ meta, ...props }) => (
    <Select options={options} {...props} />
);

export default TypeField;
